/** Canonical bron voor careers site / webhook-sollicitaties. */
export const CANDIDATE_SOURCE_WEBSITE = 'Website';

export function normalizeCandidateSource(value: unknown): string {
    return String(value ?? '').trim();
}

/** Handmatig aanmaken / CV-mapper: bron is verplicht. */
export function isCandidateSourceFilled(value: unknown): boolean {
    return normalizeCandidateSource(value).length > 0;
}

/** Sollicitant via site/webhook — altijd Website tenzij expliciet een andere recruiter-bron is meegegeven. */
export function resolveApplicantCandidateSource(explicit?: unknown): string {
    const src = normalizeCandidateSource(explicit);
    if (!src) return CANDIDATE_SOURCE_WEBSITE;
    return src;
}
